import axios from 'axios';
/**
 * cấu hình toàn bộ các url của các api microservice theo phân hệ
 * @author DNThang - 03.07.2019
 * @Edit NDQUAN - 10/08/2019
 */
//Lấy DNS môi trường
let host = process.env.VUE_APP_SERVERHOST;
// console.log('Port:: ' + process.env.PORT);
// console.log('Env:: ' + process.env.NODE_ENV);
// console.log('HostProcess:: ' + host);

//Cấu hình api config dành cho môi trường local
const apiConfigDevLocal = {
	PaymentAPI: host + ':2139/api',
	ManagementAPI: host + ':2410/api',
	DeclareAPI: host + ':20567/api',
};

//Cấu hình api config dành cho môi trường production
// const apiConfigProduction = {
// 	PaymentAPI: host + '/api/pay',
// 	ManagementAPI: host + '/api',
// 	DeclareAPI: host + '/api/dec'
// };
//Nếu chạy trong Amis App thì thêm tiền tố /mtax vào trước path api
const amisPrefix = window.__env.siteConfig.isAmisApp ? '/mtax' : '';
const apiConfigProduction = {
	PaymentAPI: amisPrefix + '/api/pay',
	ManagementAPI: amisPrefix + '/api',
	DeclareAPI: amisPrefix + '/api/dec',
};

// Cấu hình api
const api = {
	production: apiConfigProduction,
	pilot: apiConfigProduction,
	staging: apiConfigProduction,
	development: apiConfigDevLocal,
};

export default api[process.env.NODE_ENV];
